import { render, staticRenderFns } from "./SearchResultTabsVenuesList.vue?vue&type=template&id=94946d1e&"
import script from "./SearchResultTabsVenuesList.vue?vue&type=script&lang=js&"
export * from "./SearchResultTabsVenuesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem})
